import { create } from 'zustand';
import { EN_MESSAGES } from '../i18n/messages/en.js';

const LOCAL_KEY = 'aic_i18n';

function loadLocal() {
  try {
    const raw = localStorage.getItem(LOCAL_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function saveLocal(payload) {
  try {
    localStorage.setItem(LOCAL_KEY, JSON.stringify(payload));
  } catch {
    // ignore
  }
}

const initial = loadLocal() || {};

export const useI18nStore = create((set) => ({
  locale: initial.locale || 'en',
  messages: { ...EN_MESSAGES, ...(initial.messages || {}) },
  available: initial.available || [{ code: 'en', name: 'English', is_default: true }],

  setBundle: ({ locale, messages, available }) =>
    set((prev) => {
      const next = {
        locale: locale || prev.locale || 'en',
        messages: { ...EN_MESSAGES, ...(messages || {}) },
        available: available?.length ? available : prev.available,
      };
      saveLocal(next);
      return next;
    }),

  setLocale: (locale) =>
    set((prev) => {
      const next = { ...prev, locale: locale || 'en' };
      saveLocal(next);
      return next;
    }),
}));
